import { TableCell, TableHead, cn } from "@rarible_int/anaconda_ui_components"

interface CellProps extends React.ComponentProps<typeof TableCell> {
  children: React.ReactNode
  className?: string
}

export function HeaderCell({ children, className }: CellProps) {
  return (
    <TableHead className={cn("text-right", className)}>{children}</TableHead>
  )
}

export function Cell({ children, className, ...props }: CellProps) {
  return (
    <TableCell className={cn("p-0 text-right", className)} {...props}>
      {children}
    </TableCell>
  )
}
